import React, { useState } from 'react';
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Input, Button, Card, Typography, Layout } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { FacebookOutlined, TwitterOutlined, InstagramOutlined, LinkedinOutlined } from '@ant-design/icons';

import GenaLoader from "../../../../utils/components/GenaLoader/GenaLoader";

import appLogo from '../../../../assets/icons/genascreen-logo.png'
import './ContactUs.css';
import MailIcon from "../../../../assets/icons/Mail-Black.png";
import UtilHelper from '../../../../utils/UtilHelper';
import { contactUsRequest } from '../../AuthenticationApiActions';
import Notification from '../../../../utils/Notification';
import MessageModal from "../../../../utils/components/MessageModal/MessageModal";
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'

const { Header, Content } = Layout
const { Title } = Typography
const notification = new Notification()

const ContactUsForm = (props) => {
  const history = useHistory()
  // const { getFieldDecorator } = props.form;
  const [showLoader, setShowLoader] = useState(false)

  const onSubmit = (values) => {
    // e.preventDefault();
    // props.form.validateFields((err, values) => {
      // if (!err) {
        notification.show('info', 'Thanks for your interest!', 'One of our team members will reach out to you shortly with more details.')
        setTimeout(() => {
          history.push('/')
        }, 3000)
        
        // this.refs.messageModal.setState({
        //   showModal: true,
        //   title: 'Thanks for your interest!',
        //   message: 'One of our team members will reach out to you shortly with more details. In the meantime, explore how we can help you get started.',
        //   showOkButton: true,
        //   handleOk: () => history.push('/signin'),
        //   okText: 'Ok'
        // });

        // setShowLoader(true)
        // props.contactUs(values).then(res => {

        // }).catch((err) => {

        // }).finally(() => setShowLoader(false))
      // }
    // });
  };

  return (
    <Layout className="gs-app-layout">
      <Header className="gs-app-header">
        <img src={appLogo} alt='Application Logo' style={{ height: '48px' }} />
        <Button href="/signin">
          Login
          <CustomIcon name="LockClosed" />
          {/* <LockOutlined /> */}
        </Button>
      </Header>
      <Content className="gs-app-content">
        <div className="contact-us-wrapper">
          <div className="contact-us-container">
            <div className="contact-us-header">
                <div className="gs-theme__icon-frame">
                  <CustomIcon name="Mail" width={40} height={40} />
                  {/* <img src={MailIcon} alt='Application Logo' style={{ height: '40px', width: '40px' }} /> */}
                </div>
                <Title level={2} style={{ margin: 0 }}>Contact</Title>
                <div>Our support team will respond soon.</div>
            </div>
            <div className="contact-us-content">
              <Form
                form={props.form}
                id="contact-us-form"
                layout="vertical"
                onFinish={onSubmit}
              >
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, whitespace: true, message: 'Please enter name' },
                    { max: 50, message: 'Maximum 50 characters allowed' }
                  ]}
                >
                  <Input placeholder="Your Name" />
                </Form.Item>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, whitespace: true, message: 'Please enter email address' },
                    { type: 'email', message: 'Please enter a valid email address' },
                  ]}
                >
                  <Input placeholder="Your Email" />
                </Form.Item>
                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    { required: true, whitespace: true, message: 'Please enter message' },
                    { max: 1024, message: 'Maximum 1024 characters allowed' }
                  ]}
                >
                  <Input.TextArea placeholder="Your Message" rows={4} />
                </Form.Item>
                <Form.Item>
                  <Button className="margin-top-2" type="primary" htmlType="submit" block>
                    Send Message
                    <CustomIcon name="Mail" />
                  </Button>
                </Form.Item>
              </Form>
            </div>
            <div className="contact-us-footer">
              <div>Follow Us</div>
              <div className="flex-horizontal" style={{ justifyContent: 'center', gap: '8px' }}>
                <Button size='medium' icon={<CustomIcon name="InstagramLogo" />}/>
                <Button size='medium' icon={<CustomIcon name="FacebookLogo" />}/>
                <Button size='medium' icon={<CustomIcon name="LinkedinLogo" />}/>
              </div>
            </div>
          </div>
        </div>
      </Content>
      <GenaLoader showLoader={showLoader} />
      {/* <MessageModal ref="messageModal" /> */}
    </Layout>
  );
};

let ContactUs = (props) => {
  const [form] = Form.useForm();
  return <ContactUsForm form={form} {...props} />;
};

const mapStateToProps = state => {
  return {}
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    contactUs: (data) => {
      return dispatch(contactUsRequest(data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    }
  }
};

ContactUs = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUs);

export default ContactUs;
